<template>
  <footer class="bg-white border border-t border-gray-200 pt-8">
    <div class="container">
      <div class="row">
        <div class="col md:w-4/12 md:mt-0 mb-6">
          <div class="flex items-center">
            <nuxt-link :to="{ name: 'landing.home' }">
              <base-image
                :src="ImageLogo"
                title="لوگو تامینیفای"
                :width="64"
                :height="64"
                class="w-10 h-10"
              />
            </nuxt-link>

            <div class="mr-2">
              <div class="text-base">تامینیفای</div>

              <p class="text-xxs text-gray-500">چون سود کاسبی تو خریدشه</p>
            </div>
          </div>

          <p class="text-sm text-gray-600 leading-loose mt-3">
            تامینیفای پلتفرم خرید عمده پوشاک است که به شما این امکان را می‌دهد تا با دسترسی به
            هزاران کالا، خریدی سریع، اقتصادی و مطمئن را تجربه کنید.
          </p>
        </div>

        <div class="col sm:w-6/12 md:w-4/12 mb-6">
          <h2 class="text-sm text-gray-600 font-bold">تماس با ما</h2>

          <div class="text-sm text-gray-600 mt-4">
            <div class="flex items-center">
              <base-icon
                name="location"
                class="text-xl text-gray-500 ml-2"
              />
              قم، پردیسان، خیابان مولوی، پارک علم و فناوری
              <a
                href="https://nshn.ir/ac_bsAK2Oxs2wl"
                class="inline mr-1"
              >
                (لوکیشن)
              </a>
            </div>

            <div class="flex items-center mt-6">
              <base-icon
                name="phone-calling"
                class="text-xl text-gray-500 ml-2"
              />
              09052555349
            </div>
          </div>
        </div>

        <div class="col sm:w-6/12 md:w-4/12 mb-6">
          <ul class="flex justify-center mt-4">
            <li class="flex-center bg-body-50 rounded w-20 p-2 ml-2 mb-2">
              <a
                referrerpolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=545729&Code=7taUk3ukcRv9dYObov2x1q626If9ZZla"
                aria-label="enamad logo"
                rel="nofollow"
              >
                <img
                  referrerpolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=545729&Code=7taUk3ukcRv9dYObov2x1q626If9ZZla"
                  alt="تصویر اینماد سایت تامینیفای"
                  style="cursor: pointer"
                  code="7taUk3ukcRv9dYObov2x1q626If9ZZla"
                  width="125"
                  height="136"
                  loading="lazy"
                />
              </a>
            </li>

            <li class="flex-center bg-body-50 rounded w-20 p-2 ml-2 mb-2">
              <a
                href="http://qomstp.ir"
                target="_blank"
                rel="nofollow"
              >
                <base-image
                  :src="ImagePark"
                  alt="لوگو پارک علم و فناوری قم"
                  class="object-contain"
                  :width="96"
                  :height="112"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <hr />

      <div class="flex flex-col sm:flex-row justify-between items-center py-6 sm:py-4">
        <div class="text-xs text-gray-500 sm:text-center">تمامی حقوق نزد تامینیفای محفوظ است.</div>

        <!--        <ul class="flex space-x-3 rtl:space-x-reverse mt-6 sm:mt-0" data-v-4ead2b6d="">-->
        <!--          <li>-->
        <!--            <a-->
        <!--              href="https://t.me/Taminify_kids"-->
        <!--              target="_blank"-->
        <!--              class="w-8 h-8 flex-center bg-body-50 rounded text-center text-gray-600 p-2"-->
        <!--              aria-label="لینک کانال تلگرامی تامینیفای"-->
        <!--            >-->
        <!--              <base-icon name="telegram"/>-->
        <!--            </a>-->
        <!--          </li>-->
        <!--        </ul>-->
      </div>
    </div>
  </footer>
</template>

<script setup>
import ImagePark from '~/assets/images/core/logo-park.png';
import BaseImage from '~/components/base/BaseImage.vue';
import ImageLogo from '~/assets/images/core/logo-64.png';
import BaseIcon from '~/components/base/BaseIcon.vue';
</script>

<style scoped></style>
